import axios from "axios";

import { Attribution } from "../attribution";

const BACKEND_URL = process.env.REACT_APP_READABLE_BACKEND_URL!;

// 通信自体が失敗したときのエラーコード。これだけは次回の同期で回復しうる
export const REQUEST_FAILED = "request-failed";

/**
 * このリクエストで初めて検知された購入
 *
 * GA4 / Google 広告タグへ送る購入情報。クリック識別子は返さず、
 * Google 広告タグはブラウザ側の情報、backend は保存済みの識別子を使う。
 */
export interface DetectedPurchase {
  transactionId: string;
  plan: string;
  value: number;
  currency: string;
  purchasedAt: number;
}

export interface ConversionSyncResult {
  ok?: boolean;
  purchases?: DetectedPurchase[];
  error?: string;
}

/**
 * クリック識別子を UID に紐づけ、新しく検知された購入を受け取る
 *
 * 同じ購入が返るのは 1 回だけ（backend が Firestore のトランザクションで保証している）。
 * 複数のタブや端末から同時に呼んでも、購入イベントが二重に発火することはない。
 */
export const syncConversions = async (
  attribution: Attribution,
): Promise<ConversionSyncResult> => {
  try {
    const response = await axios.post(
      BACKEND_URL + "conversion/sync/",
      { attribution },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("SyncConversions error:", error);
    return { error: REQUEST_FAILED };
  }
};
